import TariffOperands from "../../../utils/services/project/accounting/tariffPlanOperandsService";
import crudTemplate from "../../../templates/crudTemplate";
let crud = crudTemplate(TariffOperands);
function prepareItem(i) {
  i.modifier_name = i._modifier && i._modifier.name;
  i.modifier_id = i._modifier && i._modifier.id;
  i._meter_unit = i._meter_unit || { id: null };
  i.meter_unit_name = i._meter_unit && i._meter_unit.name;
  i.meter_unit_id = i._meter_unit && i._meter_unit.id;
  i.consumption_metering = i._meter_unit.id || null;
  i.path = [];
  i._meter_unit.id &&
    i.path.push({
      name: i._meter_unit.name,
      id: i._meter_unit.id,
      to: "meter-unit"
    });

  return i;
}
const state = {
  ...crud.state
};

const getters = {
  ...crud.getters,
  getList(state) {
    let list = crud.getters.getList(state);

    return list.map(prepareItem);
  },
  getItem(state) {
    let item = crud.getters.getItem(state);
    item.project_id = item._project && item._project.id;
    return item.map(prepareItem);
  }
};

const actions = {
  ...crud.actions,
  create(
    _,
    { item, errorHandler = () => {}, onError = () => {}, onSuccess = () => {} }
  ) {
    item = {
      _tariff_plan: { id: item.tariff_plan_id },
      project_id: item.project_id,
      _tariff_modifier: { id: item.modifier_id },
      _meter_unit: { id: item.consumption_metering }
    };
    return crud.actions.create(_, {
      item: { ...item },
      errorHandler,
      onError,
      onSuccess
    });
  },
  update(
    _,
    { item, errorHandler = () => {}, onError = () => {}, onSuccess = () => {} }
  ) {
    item = {
      _tariff_plan: { id: item.tariff_plan_id },
      project_id: item.project_id,
      _tariff_modifier: { id: item._modifier.id },
      _meter_unit: { id: item.consumption_metering }
    };
    return crud.actions.create(_, {
      item: { ...item },
      errorHandler,
      onError,
      onSuccess
    });
  }
};

const mutations = {
  ...crud.mutations
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
